export default "__VITE_PUBLIC_ASSET__77e581a4__"